<app-job-select-customer-modal [job]='this.job'></app-job-select-customer-modal>
<p><strong>Customer: {{ this.job.order.account.name }}</strong></p>
<p><strong>Site: {{ this.job.order.site.name }}</strong></p>

<button class='btn btn-primary' (click)='openCustomerModal()'>Select Customer & site</button>
<br />
<br />

<div class='form-row'>
  <div class="form-group">
    <input type="radio" [checked]='this.vehicleOption === "own"' name='group[]' (change)="this.onOptionSelect($event, 'own')"/>
    <label for="inputEmail4">&nbsp;&nbsp;Own Vehicle</label>
  </div>
  <div class="form-group">
    &nbsp;&nbsp;<input [checked]='this.vehicleOption === "sub"'  type="radio" name='group[]' (change)="this.onOptionSelect($event, 'sub')"/>
    <label for="inputEmail4">&nbsp;&nbsp;Subcontractor</label>
  </div>
</div>


<div class='form-row'>
  <div class="form-group col-md-4">
    <label>Date</label>
    <input class='form-control' type='date' [value]='this.job.date'/>
  </div>
  @if (this.vehicleOption === "own") {
    <div class="form-group col-md-4">
      <label>Vehicle</label>
      <select class='form-control' (change)='this.job.jobAssignment.vehicleId = +$event.target.value;this.updateDepot()'>
        <option value='-1'>Select a vehicle</option>
        @for (vehicle of this.vehicles; track vehicle) {
          <option [selected]='this.job.jobAssignment.vehicleId === vehicle.id' [value]='vehicle.id'>{{  vehicle.registration }}</option>
        }
      </select>
    </div>
  }
  @if (this.vehicleOption === "own") {
    <div class="form-group col-md-4">
      <label>Driver</label>
      <select class='form-control' (change)='this.job.jobAssignment.driverId = +$event.target.value'>
        <option value='-1'>Select a driver</option>
        @for (driver of this.drivers; track driver) {
          <option [selected]='this.job.jobAssignment.driverId === driver.id' [value]='driver.id'>{{ driver.firstName }} {{  driver.lastName }}</option>
        }
      </select>
    </div>
  }
  @if (this.vehicleOption === "sub") {
    <div class="form-group col-md-4">
      <label>Subcontractor</label>
      <select class='form-control' (change)='this.job.jobAssignment.subcontractorId = +$event.target.value'>
        <option value='-1'>Select a subcontractor</option>
        @for (item of this.subcontractors; track item) {
          <option [selected]='this.job.jobAssignment.subcontractorId === item.id' [value]='item.id'>{{ item.name  }}</option>
        }
      </select>
    </div>
  }

  <div class="form-group col-md-4">
    <label for="inputEmail4">PO Number</label>
    <input type="text" name='name' [(ngModel)]='this.job.order.poNumber' class="form-control" id="inputEmail4">
  </div>
  <!-- if skip order then select skip order type -->
  @if (this.job.order.orderTypeId === 1) {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Skip Order Type</label>
      <select class='form-control' [class.is-invalid]='this.job.order.skipOrderTypeId === -1' (change)='this.job.order.skipOrderTypeId = +$event.target.value; this.job.order.skipOrderType.id = this.job.order.skipOrderTypeId'>
        <option value='-1'>Select a skip order type</option>
        @for (item of this.skipOrderTypes; track item) {
          <option [value]='item.id' [selected]='this.job.order.skipOrderTypeId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  }
  @if (this.job.order.orderTypeId === 1) {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Container Size</label>
      <select class='form-control' [class.is-invalid]='this.job.order.containerSizeTypeId === -1' (change)='this.job.order.containerSizeTypeId = +$event.target.value; this.job.order.containerSizeType.id = this.job.order.containerSizeTypeId;'>
        <option value='-1'>Select a container size</option>
        @for (item of this.containerSizes; track item) {
          <option [value]='item.id' [selected]='this.job.order.containerSizeTypeId === item.id'>{{ item.size + ' ' + item.unit.name }}</option>
        }
      </select>
    </div>
  }
  @if (this.job.order.orderTypeId === 1) {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Container type</label>
      <select class='form-control' [class.is-invalid]='this.job.order.containerTypeId === -1' (change)='this.job.order.containerTypeId = +$event.target.value; this.job.order.containerType.id = this.job.order.containerTypeId;'>
        <option value='-1'>Select a container type</option>
        @for (item of this.containerTypes; track item) {
          <option [value]='item.id' [selected]='this.job.order.containerTypeId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  }
  @if (this.job.order.orderTypeId === 1) {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Grade</label>
      <select class='form-control' [class.is-invalid]='this.job.order.gradeId === -1' (change)='this.job.order.gradeId = +$event.target.value; this.job.order.grade.id = this.job.order.gradeId;'>
        <option value='-1'>Select a grade</option>
        @for (item of this.grades; track item) {
          <option [value]='item.id' [selected]='this.job.order.gradeId === item.id'>{{ item.name }}({{ item.ewcCodes }})</option>
        }
      </select>
    </div>
  }
  <div class="form-group col-md-4">
    <label for="inputEmail4">Tip Site</label>
    <select class='form-control' [class.is-invalid]='this.job.order.tipSiteId === -1' (change)='this.job.order.tipSiteId = +$event.target.value; this.job.order.tipSite = {}; this.job.order.tipSite.id = this.job.order.tipSiteId;'>

      <option value='-1'>Select a tip site</option>
      @for (item of this.tips; track item) {
        <option [value]='item.id' [selected]='this.job.order.tipSiteId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>

  <div class="form-group col-md-4">
    <label for="inputEmail4">Driver Start Time</label>
    <input type="time" name='name' [(ngModel)]='this.job.jobAssignment.driverStartTime' class="form-control" id="inputEmail4">
  </div>

</div>
